import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';

const MetadataToken = new InjectionToken('MetadataToken');
const MailChimpConfig = new InjectionToken('MailChimpConfig');
const GoogleTagManagerEventsConfig = new InjectionToken('GoogleTagManagerEvents');
const EndpointUrl = new InjectionToken('EndpointUrl');
const BffEndPointURL = new InjectionToken('BffEndPointURL');
const ZMP_G2G_BFF_ENDPOINT_URL = new InjectionToken('ZMP_G2G_BFF_ENDPOINT_URL');
const FirebaseAppConfigToken = new InjectionToken('firebaseAppConfig');

class AppHelperService {
    constructor(metadata, meta, title) {
        this.meta = meta;
        this.title = title;
        const descriptionTag = meta.getTag('name="description"');
        this.originalMeta = {
            title: title.getTitle(),
            description: !!descriptionTag ? descriptionTag.content : '',
            url: window.location.href,
            imageURL: !!metadata ? metadata.imageURL : null
        };
        const initialTags = [
            { name: 'author', content: metadata.author },
            { name: 'keywords', content: metadata.keywords },
            { name: 'description', content: metadata.description || this.originalMeta.description }
        ];
        this.meta.addTags(initialTags);
    }
    setPageTitle(title) {
        this.title.setTitle(!!title ? `${title}` : this.originalMeta.title);
        this.meta.updateTag({ property: 'og:title', content: !!title ? title : this.originalMeta.title });
        this.meta.updateTag({ name: 'twitter:title', content: !!title ? title : this.originalMeta.title });
    }
    setPageDescription(content) {
        this.meta.updateTag({ name: 'description', content: !!content ? content : this.originalMeta.description });
        this.meta.updateTag({ property: 'og:description', content: !!content ? content : this.originalMeta.description });
        this.meta.updateTag({ name: 'twitter:description', content: !!content ? content : this.originalMeta.description });
    }
    setOGPageImage(url) {
        this.meta.updateTag({ property: 'og:image', content: !!url ? url : this.originalMeta.imageURL });
    }
    setOGURL(url) {
        this.meta.updateTag({ property: 'og:url', content: !!url ? url : this.originalMeta.url });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHelperService, deps: [{ token: MetadataToken }, { token: i1.Meta }, { token: i1.Title }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHelperService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AppHelperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MetadataToken]
                }] }, { type: i1.Meta }, { type: i1.Title }] });

class CoreModule {
    static forRoot(zwpConfig) {
        return {
            ngModule: CoreModule,
            providers: [
                { provide: EndpointUrl, useValue: zwpConfig.endpointUrl },
                { provide: MetadataToken, useValue: zwpConfig.metadata },
                { provide: BffEndPointURL, useValue: zwpConfig.BffEndPointURL },
                { provide: ZMP_G2G_BFF_ENDPOINT_URL, useValue: zwpConfig.ZMP_G2G_BFF_ENDPOINT_URL },
                { provide: MailChimpConfig, useValue: zwpConfig.mailChimpConfig },
                { provide: GoogleTagManagerEventsConfig, useValue: zwpConfig.googleTagManagerEventsConfig }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CoreModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoreModule, providers: [
            AppHelperService,
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    providers: [
                        AppHelperService,
                    ]
                }]
        }] });

const FirebaseDatabasePaths = {
    ADS_CONFIGURATION: {
        BANNER_SWIPER_PATH: '/appData/adsConfiguration/bannerSwiper',
        SOCIAL_SWIPER_PATH: '/appData/adsConfiguration/socialMediaSwiper',
        WHY_GOOD2GO_SWIPER_PATH: '/appData/adsConfiguration/whyGood2GoSwiper'
    },
    PLANS_CONFIGURATION: {
        PLAN_ADD_ONS: '/appData/plansConfiguration/planAddOns',
        PLANS: '/appData/plansConfiguration/plans'
    },
    SHOP_CONFIGURATION: {
        CATEGORIES: '/appData/shopConfiguration/categories',
        PHONE_DETAILS: '/appData/shopConfiguration/phoneDetails'
    },
    TAX_CONFIGURATION: {
        TAXES: '/appData/taxConfiguration/taxes',
        BASE: '/appData/taxConfiguration'
    },
    INTERNATIONAL_CALL_CONFIGURATION: {
        BASE: '/appData/internationalCallingConfiguration',
        RATES: '/appData/internationalCallingConfiguration/ratePerMinute',
        ELIGIBILITY: '/appData/internationalCallingConfiguration/unlimitedPlanEligibility'
    },
    SHIPPING_CONFIGURATION: {
        METHODS: '/appData/shippingConfiguration/shippingMethods',
        NEW_SIM_ORDER: '/appData/shippingConfiguration/newSimOrder',
        BASE: '/appData/shippingConfiguration'
    },
    MANUFACTURER_CONFIGURATION: {
        BASE: '/appData/phonesConfiguration'
    },
    DEALERS: {
        BASE: '/dealersData'
    },
    CONTACT_US_LOGS: {
        CANCEL_PLAN_FEEDBACK: '/userData/contactUsLogs/cancelPlanFeedback',
        CONTACT_US: '/userData/contactUsLogs/contactUs',
        BASE: '/userData/contactUsLogs'
    },
    USER_PROFILE: getUserProfilePath,
    USER_CART: getUserCartPath,
    USER_PLANS: getUserPlanPath,
    USER_PENDING_PLANS: getUserPendingPlanPath,
    USER_ACCOUNTS: getUserAccountsPath,
    USER_SHIPPING_ADDRESSES: getUserShippingAddressesPath,
    USER_PAYMENT_METHODS: getUserPaymentMethodsPath,
    USER_CANCEL_PLAN_FEEDBACK_LOG: getUserCancelPlanFeedbackLogsPath,
    USER_EBB_DETAILS: getUserEBBPath,
};
const GoogleAPIConfig = {
    placesApiUrl: getPlacesApiUrl,
    placesDetailsApiUrl: getPlacesDetailsApiUrl
};
function getUserEBBPath(userId) {
    return `/usersData/ebb/${userId}`;
}
function getUserProfilePath(userId) {
    return `/usersData/profiles/${userId}`;
}
function getUserCartPath(userId) {
    return `/usersData/carts/${userId}`;
}
function getUserPlanPath(userId, planKey) {
    return `/usersData/plans/${userId}/${planKey || ''}`;
}
function getUserPendingPlanPath(userId, planKey) {
    return `/usersData/pendingPlans/${userId}/${planKey || ''}`;
}
function getUserShippingAddressesPath(userId, addressId) {
    return `/usersData/profiles/${userId}/shippingAddresses/${addressId || ''}`;
}
function getUserPaymentMethodsPath(userId, id) {
    return `/usersData/profiles/${userId}/paymentMethods/${id || ''}`;
}
function getPlacesApiUrl(input, latitude, longitude) {
    return `/api/placeautocomplete?searchTerm=${encodeURIComponent(input) || ''}&latitude=${latitude}&longitude=${longitude}`;
}
function getPlacesDetailsApiUrl(input) {
    return `/api/placedetails?searchTerm=${encodeURIComponent(input) || ''}`;
}
function getUserAccountsPath(userId) {
    return `/usersData/accounts/${userId}`;
}
function getUserCancelPlanFeedbackLogsPath(userId, planKey) {
    return `/usersData/contactUsLogs/cancelPlanFeedback/${userId}/${planKey}`;
}

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppHelperService, BffEndPointURL, CoreModule, EndpointUrl, FirebaseAppConfigToken, FirebaseDatabasePaths, GoogleAPIConfig, GoogleTagManagerEventsConfig, MailChimpConfig, MetadataToken, ZMP_G2G_BFF_ENDPOINT_URL, getPlacesApiUrl, getPlacesDetailsApiUrl, getUserAccountsPath, getUserCancelPlanFeedbackLogsPath, getUserCartPath, getUserEBBPath, getUserPaymentMethodsPath, getUserPendingPlanPath, getUserPlanPath, getUserProfilePath, getUserShippingAddressesPath };
